let Cookie = {
  /**
   * @name cookie常用方法封装
   * @param {*} cookieName 对应cookie的Name
   * @param {*} value 对应cookie的Value
   * @param {*} expiremDays cookie时间设置单位是（天/24小时）
   */

  // 设置cookie
  setCookie: function (cookieName, value, expiremDays) {
    var exdate = new Date()
    exdate.setTime(exdate.getTime() + expiremDays * 24 * 60 * 60 * 1000)
    document.cookie = cookieName + '=' + escape(value) + ((expiremDays == null) ? '' : ';expires=' + exdate.toGMTString())
  },

  // 读取cookie
  getCookie: function (cookieName) {
    if (document.cookie.length > 0) {
      var cookieStart = document.cookie.indexOf(cookieName + '=')
      // eslint-disable-next-line eqeqeq
      if (cookieStart != -1) {
        cookieStart = cookieStart + cookieName.length + 1
        var cookieEnd = document.cookie.indexOf(';', cookieStart)
        // eslint-disable-next-line eqeqeq
        if (cookieEnd == -1) {
          cookieEnd = document.cookie.length
        }
        return unescape(document.cookie.substring(cookieStart, cookieEnd))
      }
    }
    return ''
  },

  // 删除cookie
  delCookie: function (cookieName) {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = this.getCookie(cookieName)
    if (cval != null) {
      document.cookie = cookieName + '=' + cval + ';expires=' + exp.toGMTString()
    }
  }
}
export default Cookie



// WEBPACK FOOTER //
// ./src/common/js/cookie.js